<!--
    警告：之前使用 el-row 来改造，结果排版很难微调；现在为了能够精细的调整，改成了 flex + span 的方式。

    喜欢和收藏的设计
    1. 如何加载状态
       有两种抉择，一是每次都实时的与服务器交互是否喜欢或者收藏了该 Entity 然后更新组件状态。二是，不实时与服务器进行交互，将 User 的所有的
       favorites 和 likes 值都缓存到客户端，直接与缓存客户端进行交互，只有当写入的时候，需要与服务器交互。为了节约带宽，我毫不犹豫的选择方案
       二，不过选择这个方案后，带来的额外的代价是，客户端和服务器端必须双写并保持数据状态一致。
    2. 用户登入和登出更新状态
       当用户以 Single page 的方式访问到某个 Entity 页面后，点击了喜欢和收藏，状态此时是 Actived 的了。但是如果用户一旦登出，这些状态应当被
       清空，因为此时用户不再登录的状态中了。这个时候，通过捕获用户的登出和登入的事件，进行状态相应的设置即可。

    下面是使用 el-popconfirm 的相关注意事项，
    1. 之前使用气泡确认弹框一直没有成功是因为忘了填充 reference slot 了! 另外文档中没有提到 disabled 可以禁用！
    2. 要特别注意，isLikeConfirm 只有在初始化的时候对 el-popconfirm 管用，之后如果再次设置 isLikeConfirm = false，将会出现问题，因此
       这种方式目前只适合 user likes/favortes page

    ===> 现在已经统一使用 PhoneFavorite.vue 了，逻辑几乎都是差不多的，布局上使用 PhoneFavorite.vue 进行统一了。
-->
<template>
    <div style="display:flex;margin-left:13px"> <!--向右挪动一点，否则看起来右侧很空-->
        <span style="width:10%" align="left" class="margin-right-3px">
            <el-popconfirm
                confirm-button-text='移除'
                cancel-button-text='不用了'
                icon="el-icon-info"
                icon-color="red"
                :disabled="!isLikeConfirm"
                @confirm="confirmUnLikes"
                :title="this.$store.getters.getDisplayMode().unlike.confirmMsg">
                <iconfont-selector-tooltip :is-actived="isLiked"  ref="likeSelector"
                                           default-class="iconfont icon-sy-love"
                                           actived-class="iconfont icon-sy-love-fill"
                                           actived-color="#ed4956"
                                           :line-height="30"
                                           :tooltip-text="'点赞该'+type"
                                           :disabled="isLikeDisabled"
                                           slot="reference"
                                           @change="handleLikes"/>
            </el-popconfirm>
        </span>

        <span style="width:10%;" align="left" class="margin-right-3px">
            <el-popconfirm
                confirm-button-text='移除'
                cancel-button-text='不用了'
                icon="el-icon-info"
                icon-color="red"
                :disabled="!isFavoriteConfirm"
                @confirm="confirmUnFavorites"
                :title="this.$store.getters.getDisplayMode().unfavorite.confirmMsg">
                <iconfont-selector-tooltip :is-actived="isFavorited"  ref="favoriteSelector"
                                           default-class="iconfont icon-sy-favorite"
                                           actived-class="iconfont icon-sy-favorite-fill"
                                           :font-size="26"
                                           :line-height="30"
                                           :tooltip-text="'收藏该'+type"
                                           :disabled="isFavoriteDisabled"
                                           slot="reference"
                                           @change="handleFavorite"/>
            </el-popconfirm>
        </span>
        <span style="width:10%" align="left">
            <iconfont-selector-tooltip :is-actived="true"
                                       default-class="el-icon-chat-round"
                                       actived-class="el-icon-chat-round"
                                       default-color="#2c3e50"
                                       actived-color="#2c3e50"
                                       :font-size="24"
                                       :line-height="30"
                                       :handler="focusInput"
                                       tooltip-text="评论"
                                       :style="{'margin-left': '2px'}" />
        </span>
        <span style="line-height:30px; margin-left:12px; width: 70%" align="left">
            <span style="padding-right:6px;">{{e.likes.toLocaleString()}}</span><span class="font-gray">喜欢了该{{type}}</span>
        </span>
    </div>
</template>

<script>

    import {Entity, errorMessage, getCachedUser, warningMessage} from "../../../utils";
    import {CachedApiSecurity} from "../../../api-security";
    import {likes, favorites} from "../../../data/user";
    import {vue} from "../../../main";
    import {loadingInstance} from "../../../utils";

    export default {
        name: "Favorite",
        props: {
            e: null,  // the entity
        },
        data() {
            return {
                isLiked: false,  // 用来控制喜欢 icon 的状态变化
                isLikeConfirm: false, // 发起喜欢操作是否需要 confirm？这个主要是针对 user likes center 的取消喜欢而设计的。
                isLikeDisabled: false,
                isFavorited: false, // 用来控制收藏 icon 的状态变化
                isFavoriteConfirm: false, // 同上
                isFavoriteDisabled: false,
            }
        },
        computed: {
            // 资源的类别
            type: function(){
                return Entity.getType(this.e).name;
            },
            // 写 isLiked/isFavorited computed 属性的目的是，当用户退出，重置相关的状态。但是实测，computed 属性并不会随没有被 vue 状态
            // 控制的属性（即这里是指 getCachedUser().likes）的变化而变化。因此下面的做法无效。因此还是还原为 created() 的做法。
            // ----------------------------------------
            // isLiked: function(){
            //     if( CachedApiSecurity.isSignedIn() ){
            //         return getCachedUser().likes.includes(this.e.shortcode);
            //     }
            // },
            // isFavorited: function(){
            //     if( CachedApiSecurity.isSignedIn() ){
            //         return getCachedUser().favorites.includes(this.e.shortcode);
            //     }
            // }
            // ----------------------------------------
        },
        created() {
            this.init();
            // this -> 是 Favorite，下面的监听表示是 Favorite 组件监听。
            this.$EventBus.$on('signedin', () => {
                console.log('Favorite, caught the signedin global event');
                this.init();
            });
            this.$EventBus.$on('signout', () => {
                console.log('Favorite, caught the signout global event');
                this.init();
            });
        },
        beforeDestroy() {
            // 说是（https://juejin.cn/post/6861572888420581390），在该组件被销毁的时候，需要移除该组件对该事件的监听。
            this.$EventBus.$off('signedin')
            this.$EventBus.$off('signout');
        },
        methods: {
            init(){
                console.log('Favorite init method get called~~~');
                if( CachedApiSecurity.isSignedIn() ){
                    this.isLiked = getCachedUser().likes.includes(this.e.shortcode);
                    this.isFavorited = getCachedUser().favorites.includes(this.e.shortcode);
                }else{
                    this.isLiked = false;
                    this.isFavorited = false;
                }
            },

            focusInput(){
                if( !CachedApiSecurity.isSignedIn() ){
                    console.log('the user has not cached signed in');
                    CachedApiSecurity.handleNoAuthorith();
                }else{
                    console.log(this.$parent.$refs.input);
                    this.$parent.$refs.input.$refs.textarea.focus();
                }
            },

            /**
             * V2: 为 usercenter likes 新增 unlikes confirm 逻辑。目前这也是耦合性最强的代码逻辑，
             */
            handleLikes(isActived){
                console.log('handle like, isActived:', isActived);
                let isLikes = isActived;  // rename it to be more meaniful.
                // 提示用户必须登录才能操作
                if( !CachedApiSecurity.isSignedIn() ){
                    console.log('the user has not cached signed in');
                    CachedApiSecurity.handleNoAuthorith();
                    this.revert("likeSelector");
                }else{
                    let mode = this.$store.getters.getDisplayMode();
                    if(!isLikes && mode.unlike.isNeedConfirm){
                        // ----------
                        // 专门为 user center likes 设计的逻辑 - unlike confirm
                        // ----------
                        console.log('likes confirm needed')
                        // 要特别注意，isLikeConfirm 只有在初始化的时候对 el-popconfirm 管用，之后如果再次设置 isLikeConfirm = false，
                        // 将会出现问题，因此这种方式目前只适合 user likes/favortes page
                        this.isLikeConfirm = true; // needs unlike confirm. confirm 后回调 confirmLikes 方法继续后续处理
                        this.isLikeDisabled = true; // 禁用 likes iconfont selector 组件。
                        this.revert("likeSelector");  // 同时模拟图标 disabled 的场景。
                    }else{
                        this.__doLikes(isLikes);
                    }
                }
            },

            /**
             * 这个方法是专门为 user center likes 提供的，确认从喜欢列表中移除后的回调方法，
             */
            confirmUnLikes(){
                console.log('confirm unlikes');
                // this.isLiked = false;  // 因为移除有一个展示过程，将其状态改变为 unchecked 用户感觉更真实。
                // 因为 iconfont 已经被禁用了，所以上述的方式只能使用下面的 revert 方式替换了
                this.revert("likeSelector");
                this.__doLikes(false);  // 确定不喜欢了，因此这里的参数一定是 false;
            },

            /**
             * 向服务器发起异步请求更新状态
             */
            __doLikes(isLikes){
                // 因为 user likes 页面需要等待确定移除以后才能滑动到下一个 entity，因此这类需要添加等待。
                let loading = null;
                let mode = this.$store.getters.getDisplayMode();
                if(!isLikes && mode.unlike.isNeedConfirm) {
                    loading = loadingInstance();
                }
                let incNum = isLikes ? 1 : -1;
                this.e.likes += incNum; // 为了没有延迟，先直接增加，若后面异步远程提交遇到延迟，再回滚。
                likes(this.e.shortcode, isLikes).then(()=>{
                    console.log(`likes ${this.e.shortcode} remote return success`);
                    // Cache likes into client（因为选择不实时与服务器发生交互查询状态，因此必须将状态值实时同步到客户端缓存）
                    isLikes ?
                        this.$store.commit('addUserLikes', this.e.shortcode) :
                        this.$store.commit('removeUserLikes', this.e.shortcode)
                    // 处理移除喜欢列表中的 entity，发出"全局事件"，由 likes dialog 捕获，并回调 list 的 remove(e) 方法移除.
                    isLikes ? '' : vue.$EventBus.$emit('unlikes', this.e.shortcode);
                }).catch((err)=>{
                    console.log(`likes ${this.e.shortcode} remote return failed`);
                    errorMessage(err.message);
                    // 以下反向操作即可 - 即回滚。
                    this.e.likes -= incNum;
                    this.revert("likeSelector");
                    isLikes ?
                        this.$store.commit('removeUserLikes', this.e.shortcode) :
                        this.$store.commit('addUserLikes', this.e.shortcode)
                }).finally(()=>{
                    if(loading !== null){
                        loading.close();
                    }
                })
            },

            handleFavorite(isActived){
                console.log('handle follows_, isActived:', isActived);
                if( !CachedApiSecurity.isSignedIn() ){
                    CachedApiSecurity.handleNoAuthorith();
                    this.revert("favoriteSelector")
                }else{
                    let isFavorites = isActived;
                    let mode = this.$store.getters.getDisplayMode();
                    if(!isFavorites && mode.unfavorite.isNeedConfirm){ // unlike
                        // ----------
                        // 专门为 user center likes 设计的逻辑 - unlike confirm
                        // ----------
                        this.isFavoriteConfirm = true; // needs unlike confirm. confirm 后回调 confirmUnFavorites 方法继续后续处理
                        this.isFavoriteDisabled = true; // 禁用 iconfont selector
                        this.revert("favoriteSelector");  // 模拟图标 disabled 的场景
                    }else{
                        this.__doFavorites(isFavorites);
                    }
                }
            },

            /**
             * 这个方法是专门为 user center likes 提供的，确认从喜欢列表中移除后的回调方法，
             */
            confirmUnFavorites(){
                console.log('confirm unfavorites');
                // this.isFavorited = false;  // 因为移除有一个展示过程，将其状态改变为 unchecked 用户感觉更真实。
                // 因为 iconfont 已经被禁用了，所以上述的方式只能使用下面的 revert 方式替换了
                this.revert("favoriteSelector");
                this.__doFavorites(false);  // 确定不喜欢了，因此这里的参数一定是 false;
            },

            /**
             * @param {Boolean} isFavorites
             */
            __doFavorites(isFavorites){
                // 因为 user favorites 页面需要等待确定移除以后才能滑动到下一个 entity，因此这类需要添加等待。
                let loading = null;
                let mode = this.$store.getters.getDisplayMode();
                if(!isFavorites && mode.unfavorite.isNeedConfirm) {
                    loading = loadingInstance();
                }
                favorites(this.e.shortcode, isFavorites).then(()=>{
                    console.log(`favorites ${this.e.shortcode} remote return success`);
                    isFavorites ?
                        this.$store.commit('addUserFavorites', this.e.shortcode) :
                        this.$store.commit('removeUserFavorites', this.e.shortcode)
                    // 处理移除收藏列表中的 entity，发出"全局事件"，由 favorite dialog 捕获，并回调 list 的 remove(e) 方法移除.
                    isFavorites ? '' : vue.$EventBus.$emit('unfavorites', this.e.shortcode);
                }).catch((err)=>{
                    console.log(`likes ${this.e.shortcode} remote return failed`);
                    errorMessage(err.message);
                    // 反向操作
                    this.revert("favoriteSelector");
                    isFavorites ?
                        this.$store.commit('removeUserFavorites', this.e.shortcode) :
                        this.$store.commit('addUserFavorites', this.e.shortcode)
                }).finally(()=>{
                    if(loading !== null){
                        loading.close();
                    }
                });
            },

            /**
             *
             * @param selector, the selector ref name
             */
            revert(selector){
                this.$refs[selector].revert();
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/entity/infoboard/Favorite.vue